import React from 'react';
import { OrderCardContainer, OrderInfo, OrderButton } from './styles';

interface OrderCardProps {
  orderId: number;
  storeId: number;
  storeName: string;
  status: string;
  total: number;
  onChatClick: () => void;
}

const OrderCard: React.FC<OrderCardProps> = ({ orderId, storeId, storeName, status, total, onChatClick }) => {
  return (
    <OrderCardContainer>
      <OrderInfo>
        <h3>Pedido #{orderId}</h3>
        <p><strong>Loja:</strong> {storeName} (ID: {storeId})</p>
        <p>Status: {status}</p>
        <p>Total: R$ {total.toFixed(2)}</p>
      </OrderInfo>
      <OrderButton onClick={onChatClick}>
        <span role="img" aria-label="Chat">💬</span>
        Falar com Suporte
      </OrderButton>
    </OrderCardContainer>
  );
};

export default OrderCard;
